const shipment = {
  shipmentMana: 'Yêu cầu vận chuyển',
  shipmentListPage: 'Đơn vận chuyển',
  add: 'Thêm',
  edit: 'Sửa',
  delete: 'Xóa',
  detail: 'Chi tiết',
  export: 'Xuất',
  import: 'Nhập',
  search: 'Tìm kiếm',
  reset: 'Đặt lại',
  confirm: 'Xác nhận',
  cancel: 'Hủy',
  cancelOk: 'Hủy thành công',
  cancelFAil: 'Hủy thất bại',
  confirmCancel: 'Bạn có chắc chắn muốn hủy đơn vận chuyển {{no}} không?',
  orderNumber: 'Số đơn hàng',
  customerName: 'Tên khách hàng',
  status: 'Trạng thái',
  sourceType: 'Loại nguồn',
  consignee: 'Người nhận',
  consigneeAddress: 'Địa chỉ nhận hàng',
  consigneePhone: 'Số điện thoại nhận hàng',
  destinationCountry: 'Nước đích',
  tradeTerms: 'Điều kiện thương mại',
  paymentTerms: 'Phương thức thanh toán',
  planShipDate: 'Ngày dự kiến vận chuyển',
  actualShipDate: 'Ngày vận chuyển thực tế',
  deliveredAt: 'Thời gian giao hàng',
  remark: 'Ghi chú',
  items: 'Chi tiết',
  createTime: 'Thời gian tạo',
  operation: 'Thao tác',
  productCode: 'Mã sản phẩm',
  productName: 'Tên sản phẩm',
  count: 'Số lượng',
  saleOrderCount: 'Số lượng đơn bán',
  amount: 'Số tiền',
  uom: 'ĐVT',
  unitPrice: 'Đơn giá',
  currency: 'Loại tiền tệ',
  itemRemark: 'Ghi chú mục',
  plKeyword: 'Nhập số đơn hàng hoặc tên khách hàng',
  shipMethod: 'Phương thức vận chuyển',
  shipLogistics: 'Đơn vị vận chuyển',
  shipEvent: 'Theo dõi vận chuyển',
  saleOrder: 'Đơn bán hàng',
  saleOrderItem: 'Dòng đơn bán hàng',
  selectOrder: 'Chọn đơn hàng',
  selectOrderItem: 'Chọn dòng đơn hàng',
  noProduct: 'Không có sản phẩm',
  customerShipAddress: 'Chọn địa chỉ nhận hàng',
  plCustomerName: 'Nhập tên khách hàng',
  plConsignee: 'Nhập người nhận',
  plConsigneePhone: 'Nhập số điện thoại người nhận',
  plConsigneeAddress: 'Nhập địa chỉ người nhận',
  plRemark: 'Nhập ghi chú',
  plTradeTerms: 'Nhập điều kiện thương mại',
  plPaymentTerms: 'Nhập phương thức thanh toán',
  plCurrency: 'Nhập loại tiền tệ',
  plCarrier: 'Nhập đơn vị vận chuyển',
  addPackOrder: 'Thêm phiếu phân loại',
  yes: 'Có',
  no: 'Không',
  number: 'Số đơn vận chuyển',
  trackingNo: 'Mã vận đơn',
  blNo: 'Số vận đơn đường biển',
  vesselVoyage: 'Tàu/chuyến',
  containerNo: 'Số container',
  shipped: 'Đã vận chuyển',
  pending: 'Chờ vận chuyển',
  shippedAt: 'Thời gian vận chuyển',
  freightCost: 'Cước phí',
  addLogistics: 'Thêm vận chuyển',
  editLogistics: 'Sửa vận chuyển',
  plTrackingNo: 'Nhập mã vận đơn',
  plBlNo: 'Nhập số vận đơn đường biển',
  plVesselVoyage: 'Nhập tàu/chuyến/chuyến bay',
  plContainerNo: 'Nhập số container',
  plFreightCost: 'Nhập cước phí',
  addError: 'Thêm thất bại',
  saveFail: 'Lưu thất bại',
  saveOk: 'Lưu thành công',
  addSuccess: 'Thêm thành công',
  freightCurrency: 'Loại tiền cước',
  noPackOrder: 'Không có phiếu phân loại',
  shipmentNoPack: 'Đơn vận chuyển không có phiếu phân loại, không thể thêm vận chuyển',
  packNoShipment: 'Phiếu phân loại không có đơn vận chuyển, không thể thêm vận chuyển',
  getPackErr: "Lấy phiếu phân loại thất bại!",
  logistics: "Đơn vận chuyển",
  eventTime: 'Thời gian sự kiện',
  location: 'Vị trí',
  description: 'Mô tả',
  shipEvents: 'Theo dõi vận chuyển',
  plLocation: 'Nhập vị trí',
  plDescription: 'Nhập mô tả',
  addEvent: 'Thêm sự kiện',
  doShip: 'Vận chuyển',
  shipOk: 'Vận chuyển thành công',
  shipFail: 'Vận chuyển thất bại',
  viewLogistics: 'Xem vận chuyển',
  creator: 'Người tạo',
  viewPackOrder: 'Xem phiếu phân loại',
  viewShipmentOrder: 'Xem đơn vận chuyển',
  repeated: 'Sản phẩm trùng lặp đã bị bỏ qua',
  addShipOutPl: "Vui lòng tạo đơn xuất kho trước!",
  hasLogis: "Đơn vận chuyển này đã có thông tin logistics",
  plSelShip: "Vui lòng chọn đơn giao hàng",
  plSelShipErr: "Chỉ có thể chọn các đơn giao hàng được tạo từ cùng một đơn phân loại",
  exportErr: "Xuất thất bại",
};

export default shipment;
